export default "__VITE_ASSET__B0LFNy4U__"